import _ from "underscore";
import * as aj from "../aj/index";
import { CATEGORIES } from "./types";
import { completed, failed } from "../utils/ajex";
import { 
    LOAD_SURVEY_TEMPLATE_WEIGHTS, 
    CLEAR_CATEGORIES, 
    DESELECT_CATEGORY, 
    DESELECT_QUESTION_TEMPLATE, 
    LOAD_ASSOCIATED_QUESTION_TEMPLATE_IDS, 
    LOAD_CATEGORIES_QUESTIONS_TREE, 
    LOAD_CATEGORY_NODES, 
    LOAD_SURVEY_TEMPLATE_CATEGORIES, 
    SELECT_CATEGORY, 
    SELECT_QUESTION_TEMPLATE, 
    SET_SELECTED_CATEGORY_IDS, 
    SET_WEIGHT, 
    LOAD_TARGET_QUESTIONS_TREE,
    LOAD_DEFAULT_SURVEY_NOTES,
    SET_NOTES,
    INIT_PRESENTATION_NOTES,
} from "../actions/types";
import { flatNodes } from "../model/nodes";
import { updatedList } from "../utils/lang";


export function getDefaultState() {
    return {
        categoryNodes: [],
        selectedCategoryIds: [],
        questionNodes: null,
        selectedQuestionTemplateIds: [],
        weights: [],
        inputValues: {},
        presentationNotes: [],
    }
}

function toInputValues(items, valueProp = "value") {
    const inputValues = {};

    items.forEach(w => {
        inputValues[w.categoryId] = w[valueProp];
    })

    return inputValues;
}

function toQuestionNodes(questionsTree) {
    const roots = [];

    questionsTree.roots?.forEach(macroarea => {
        macroarea.children?.forEach(area => {
            const areaNode = {
                id: area.id,
                description: area.category.description,
                type: "area",
                children: []
            }

            area.children?.forEach(category => {               
                const categoryNode = {
                    id: category.id,
                    description: category.category.description,
                    type: "category",
                    children: []
                }
                
                category.questions.forEach(question => {
                    const questionNode = {
                        id: question.question.template.id,
                        description: question.question.template.description,
                        type: "question",
                    }

                    categoryNode.children.push(questionNode);
                })

                areaNode.children.push(categoryNode);                
            })

            roots.push(areaNode);
        })
    })

    return roots;
}

function toCategoryNodes(questionsTree) {
    const roots = [];

    questionsTree.roots?.forEach(macroarea => {
        const macroareaNode = {
            id: macroarea.id,
            description: macroarea.category.description,
            type: "macroarea",
            children: []
        }

        macroarea.children?.forEach(area => {
            const areaNode = {
                id: area.id,
                description: area.category.description,
                type: "area",
                children: []
            }

            area.children?.forEach(category => {               
                const categoryNode = {
                    id: category.id,
                    description: category.category.description,
                    type: "category"
                }
                
                areaNode.children.push(categoryNode);                
            })

            macroareaNode.children.push(areaNode);
        })

        roots.push(macroareaNode);
    })

    return roots;
}

export const CategoriesStore = aj.createStore(CATEGORIES, (state = getDefaultState(), action) => {

    switch(action.type) {
        case completed(LOAD_CATEGORY_NODES):
            return _.assign(state, {categoryNodes: action.categoryNodes});

        case completed(LOAD_DEFAULT_SURVEY_NOTES):
            return _.assign(state, {
                presentationNotes: action.presentationNotes, 
                inputValues: toInputValues(action.presentationNotes, "notes"),
                questionNodes: toCategoryNodes(action.questionsTree)
            });

        case INIT_PRESENTATION_NOTES:
            return _.assign(state, {
                presentationNotes: action.presentationNotes, 
                inputValues: toInputValues(action.presentationNotes, "notes"),
            });

        case SELECT_CATEGORY:
            if (!(state.selectedCategoryIds ?? []).some(s => s === action.category.id)) {
                return _.assign(state, {selectedCategoryIds: [...(state.selectedCategoryIds ?? []), ...flatNodes(action.category).map(c => c.id)]});
            }

        case SET_SELECTED_CATEGORY_IDS:
            return _.assign(state, {selectedCategoryIds: action.selectedCategoryIds})

        case DESELECT_CATEGORY:
            return _.assign(state, {selectedCategoryIds: state.selectedCategoryIds?.filter(s => !flatNodes(action.category, "children", true).some(fn => fn.id == s)) ?? []});
    
        case CLEAR_CATEGORIES:
            return getDefaultState();

        case completed(LOAD_CATEGORIES_QUESTIONS_TREE):
            return _.assign(state, {questionNodes: toQuestionNodes(action.questionsTree)});

        case completed(LOAD_SURVEY_TEMPLATE_CATEGORIES):
            return _.assign(state, {selectedCategoryIds: action.categoryIds})

        case SELECT_QUESTION_TEMPLATE:
            if (!state.selectedQuestionTemplateIds.some(s => s === action.node.id)) {
                return _.assign(state, {selectedQuestionTemplateIds: [...state.selectedQuestionTemplateIds, ...flatNodes(action.node).map(c => c.id)]});
            }

        case DESELECT_QUESTION_TEMPLATE:
            return _.assign(state, {selectedQuestionTemplateIds: state.selectedQuestionTemplateIds.filter(s => !flatNodes(action.node).some(fn => fn.id == s))});
        

        case completed(LOAD_ASSOCIATED_QUESTION_TEMPLATE_IDS):
            return _.assign(state, {selectedQuestionTemplateIds: action.questionTemplateIds});

        case completed(LOAD_SURVEY_TEMPLATE_WEIGHTS):
            return _.assign(state, {
                weights: action.weights,
                inputValues: toInputValues(action.weights)
            });

        case SET_WEIGHT: {
            const newInput = {};
            newInput[action.categoryId] = action.value;
            return _.assign(state, {
                weights: updatedList(
                    state.weights, 
                    (w) => w.categoryId == action.categoryId,
                    (w) => _.assign({}, w, {categoryId: action.categoryId, value: action.value}),
                    true
                ),
                inputValues: _.assign(state.inputValues, newInput)
            })
        }

        case SET_NOTES: {
            const newInput = {};
            newInput[action.categoryId] = action.value;
            return _.assign(state, {
                presentationNotes: updatedList(
                    state.presentationNotes, 
                    (w) => w.categoryId == action.categoryId,
                    (w) => _.assign({}, w, {categoryId: action.categoryId, notes: action.value}),
                    true
                ),
                inputValues: _.assign(state.inputValues, newInput)
            })
        }

        
    }

})